import React, { useEffect, useState } from "react";
import Logo from "../../../assets/Logo.png";
import Cookies from "js-cookie";
import api from "../../../utils/api";

const RecieptPopup = ({ orderData, closePopup }) => {
  const {
    _id,
    extraNotes,
    receiverName,
    receiverPhone,
    point,
    items,
    totalPrice,
    orderNo,
    paymentMethod,
    cardHolderName,
    cash,
    createdAt,
    serviceFee,
    last4Digits,
    deliveryFee,
    cardBrand,
    orderType,
    userAddress,
    marketFee,
    restaurantId
  } = orderData;

  const [showButtons, setShowButtons] = useState(true); // State to control the visibility of the button area
 const [restaurantDetails, setRestaurantDetails] = useState(null);
//  const SavedRestaurant = Cookies.get('selectedRestaurantId')
const fetchRestaurantDetails = async (restaurantId) => {
  try {
    const response = await api.get(`/restaurant/${restaurantId}`);
    setRestaurantDetails(response.data?.data || []);
  } catch (error) {
    console.error("Error fetching restaurant details:", error);
  }
}
useEffect(() => {
  if (restaurantId) {
    fetchRestaurantDetails(restaurantId);
  }
}, [restaurantId]);
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div
        className="bg-white rounded-lg shadow-lg p-6 md:w-[90%] w-[85%] max-w-lg md:h-auto h-[80%] max-h-[90vh] overflow-y-auto"
        id="order-summary"
      >
        <div className="text-center">
          <img
            src={restaurantDetails?.logo && restaurantDetails?.logo[0] || restaurantDetails?.logo}
            alt="Logo"
            className="mx-auto mb-4 object-contain"
            style={{ maxHeight: "80px", width: "auto" }}
          />
          <p className="text-gray-500 text-sm">
            {new Date(createdAt).toLocaleString()}
          </p>
          <div className="border-t border-dashed border-gray-400 my-2"></div>
          <div className="border border-dotted border-gray-400 p-4 rounded-md inline-block">
            <h2 className="text-lg font-bold">Order No.</h2>
            <h1 className="text-2xl font-bold mb-2">{orderNo}</h1>
          </div>
          <div className="mt-4 space-y-2">
            <div className="flex justify-between">
              <span className="font-semibold">Order Id</span>
              <span>{_id?.slice(-6)}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-semibold">Customer Name</span>
              <span>{receiverName}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-semibold">Phone</span>
              <span>{receiverPhone || "---"}</span>
            </div>
            
            {orderType=== 'delivery' && (
               <div className="flex justify-between gap-5">
               <span className="font-semibold">Address</span>
               <span className=" break-words">{userAddress} </span>
             </div>
            )}
            <div className="flex flex-col justify-between items-start ">
               <span className="font-semibold">Extra Notes:</span>
               <span className=" break-words flex text-start justify-start items-start text-sm">{extraNotes || "--- "} </span>
             </div>
            {/* {orderType=== 'delivery' && (
     <div
     
     className="flex flex-col   border-gray-100 "
   >
     <span className="text-gray-500 flex justify-start items-start">Address :</span>
     <span className=" break-words text-sm flex justify-end items-end">	</span>
   </div>
   )} */}
           <div className="pt-4 text-center font-bold">Items Ordered</div>
  <div className="space-y-2">
    {items?.map((item, index) => (
      <div
        key={index}
        className="flex justify-between border-b border-gray-100 pb-1"
      >
        <span className="text-gray-500">{item.name}</span>
        <span className=" whitespace-nowrap">{item.quantity} x {item.basePrice} 	&#163;</span>
      </div>
    ))}
     <div
     
        className="flex justify-between border-t border-gray-100 "
      >
        <span className="text-gray-500">Service Fee</span>
        <span className=" whitespace-nowrap">{serviceFee} 	&#163;</span>
      </div>
   {marketFee >0 && (
      <div
     
      className="flex justify-between border-t border-gray-100 "
    >
      <span className="text-gray-500">Marketplace Fee</span>
      <span className=" whitespace-nowrap">{marketFee} 	&#163;</span>
    </div>
   )}
    {orderType === 'delivery' && (
       <div
     
       className="flex justify-between  border-gray-100 "
     >
       <span className="text-gray-500">Delivery Fee</span>
       <span className=" whitespace-nowrap">{deliveryFee} 	&#163;</span>
     </div>
    )}
  
   
  </div>
          </div>
          <div className="border-t border-dashed border-gray-400 my-2"></div>
          <div className="space-y-2">
           {point > 0 && (
             <div className="flex justify-between">
             <span className="font-semibold">Discount</span>
             {/* Use inline-block for alignment consistency */}
             <span className="inline-block">{point} %</span>
           </div>
           )}
            <div className="flex justify-between">
              <span className="font-semibold">Total Price</span>
              {/* Use inline-block for alignment consistency */}
              <span className="inline-block">{totalPrice} £</span>
            </div>

            <div className="flex justify-between">
              <span className="font-semibold">Payment Method</span>
              <span>{cardBrand}*** {last4Digits || 'wallet'}, {cardHolderName} </span>
            </div>
          </div>
          <div className="border-t border-dashed border-gray-400 my-4"></div>
          <p className="text-gray-600 text-sm text-center mb-4">
            Thanks for fueling our passion. Drop by again, if your wallet isn’t
            still sulking. You’re always welcome here!
          </p>
          {showButtons && (
            <div className="popup-buttons space-y-4">
              {/* <button
                onClick={handleDownload}
                className="mt-4 w-full bg-[#AF313D] text-white py-2 rounded-lg hover:bg-red-600"
              >
                Save
              </button> */}
              <button
                onClick={closePopup}
                className="mt-4 w-full bg-[#AF313D] text-white py-2 rounded-lg hover:bg-red-600"
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecieptPopup;
